import {buildFeatureUrl} from '@hproduce/suite-core'

export const getRcfaListUrl = (plantUpmId: string) => {
  return `${buildFeatureUrl('RcfaList', plantUpmId)}/list?page=0&type=myplant`
}

export const getDowntimeDashboardUrl = (plantUpmId: string) => {
  return buildFeatureUrl('DowntimeDashboard', plantUpmId)
}
